import common from 'src/pages/submissions/script/common.methods'
import { isEmpty } from 'lodash'
import { adobeCjaEventEmitter } from 'modules/adobe-cja/utils'
import { CJA_EVENTS, LINK_TYPES, LINK_CATEGORIES, LINK_NAMES, LINK_SECTION } from 'modules/adobe-cja/constants'

export default {
  isEmpty,
  submitSubmission() {
    const tags = this.submissionTags || []
    adobeCjaEventEmitter({
      event: CJA_EVENTS.LINK_CLICK,
      links: {
        linkCategory: LINK_CATEGORIES.FONT_FAMILY_TAGS,
        linkSection: LINK_SECTION.SUBMISSIONS,
        linkName: LINK_NAMES.SUBMIT_NEXT,
        linkType: LINK_TYPES.BUTTON
      },
      Tags: tags.map(tag => ({
        TagName: tag.name,
        TagType: tag.id === 'AI_GENERATED' ? 'AI_GENERATED' : 'user'
      }))
    })

    this.submission.userMetaData.releaseInfo = {
      releaseImmediately: this.releaseOption === this.releaseASAP
    }
    if (this.releaseOption === this.releaseSchedule) {
      Object.assign(this.submission.userMetaData.releaseInfo, { releaseDate: this.releaseDate + 'T00:00:00+00:00' })
    }
    this.submission.status = 'in_review'
    this.submission.description = this.description || ''
    this.processing = true
    this.$forceUpdate()
    this.$store
      .dispatch('submissions/update')
      .then(response => {
        /**
         * Submission successfully submitted
         * Clear timer and store listener
         */
        if (response) {
          this.processing = false
          // this.$parent.$options.methods.intervalClear(this.$parent)
          this.$parent?.$parent?.$children?.map(f => {
            if (Object.keys(f).indexOf('unsubscribe') >= 0) {
              f.unsubscribe()
            }
          })

          common.navigateToSubmissionSuccess(this)
        } else {
          this.submission.status = 'in_work'
          this.$store.commit('submissions/submitComplete')
          common.resetSubmissionObjectBuilds()
        }
      })
      .catch(() => {
        /**
         * Submission status could not set to 'in_review' due to error response from BE
         * so put it's status back to 'in_work'
         */
        this.submission.status = 'in_work'
        this.$store.commit('submissions/submitComplete')
        common.resetSubmissionObjectBuilds()
      })
  },

  setValues() {
    const releaseInfo =
      this.submission.status === 'in_correction' ? {} : this.submission.userMetaData?.releaseInfo || {}
    const releaseAsap = typeof releaseInfo.releaseImmediately === 'boolean' ? releaseInfo.releaseImmediately : true
    this.releaseDate = releaseAsap ? this.tomorrow : (releaseInfo.releaseDate || '').slice(0, 10)
    this.releaseOption = releaseAsap ? this.releaseASAP : this.releaseSchedule
    this.setDate()
  },
  setDate() {
    if (this.submission.status === 'in_correction') {
      this.submission.userMetaData.releaseInfo = {
        releaseImmediately: this.releaseOption === this.releaseSchedule
      }
      if (this.releaseOption === this.releaseSchedule) {
        Object.assign(this.submission.userMetaData.releaseInfo, { releaseDate: this.releaseDate + 'T00:00:00+00:00' })
      }
    }
  },
  validationForReleaseDate(reference) {
    if (this.banned || this.$store.getters['bannedword/checkForBannedWord']) {
      return
    }
    if (reference === 'submit_submission') {
      this.submitSubmission()
    }
    if (this.submission.status === 'in_correction') {
      this.submission.userMetaData.releaseInfo = {
        releaseImmediately: this.releaseOption === this.releaseASAP
      }
      if (this.releaseOption === this.releaseSchedule) {
        Object.assign(this.submission.userMetaData.releaseInfo, { releaseDate: this.releaseDate + 'T00:00:00+00:00' })
      }
    }
  }
}
